import React from 'react'
import { Box } from '@ztechapps/webui.util'
import { formatMoney } from '@ztechapps/common.utils'
import { useCheckoutContext } from '../../index'

export const ManualShippingRateAlertPanel = () => {
  const context = useCheckoutContext()
  const [shippingOptions] = context.shippingOptions
  const shippingFee = shippingOptions.shippingFee

  return (
    <Box>
      <Box.Body>
        <p>We setup the shipping rate and options explicitly for this order. </p>
        <div>
          Your shipping Fee:
          <h3>
            <strong>{formatMoney(shippingFee)}</strong>
          </h3>
        </div>
      </Box.Body>
    </Box>
  )
}
